import moment from 'moment/moment';
import { useState } from 'react';
import IconFilter from '../../assets/images/icon-filter.svg';
import useComponentVisible from '../../hooks/useComponentVisible';
import CustomInputDate from './CustomInputDate';
import './FilterDate.css';

const rangeDate = [
  {
    label: 'Tất cả',
    slug: 'all',
    range: {}
  },
  {
    label: 'Hôm nay',
    slug: 'today',
    range: {
      startDate: moment().startOf('day').unix(),
      endDate: moment().unix()
    }
  },
  {
    label: 'Hôm qua',
    slug: 'yesterday',
    range: {
      startDate: moment().subtract(1, 'day').startOf('day').unix(),
      endDate: moment().subtract(1, 'day').endOf('day').unix()
    }
  },
  {
    label: '7 ngày qua',
    slug: 'last_7_days',
    range: {
      startDate: moment().subtract(7, 'days').startOf('day').unix(),
      endDate: moment().unix()
    }
  },
  {
    label: 'Tháng này',
    slug: 'this_month',
    range: {
      startDate: moment().startOf('month').unix(),
      endDate: moment().unix()
    }
  },
  {
    label: 'Tháng trước',
    slug: 'last_month',
    range: {
      startDate: moment().subtract(1, 'months').startOf('month').unix(),
      endDate: moment().subtract(1, 'months').endOf('month').unix()
    }
  },
];
function FilterDate({ onSelectDate, onSelect }) {

  const [range, setRange] = useState(rangeDate[0]);

  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

  const filterHandler = (slug) => {
    const currentRange = rangeDate.find(item => item.slug === slug);
    setRange(currentRange);
    setIsComponentVisible(false);
    onSelectDate(currentRange);
  };

  const handleDateChange = (range) => {
    if (range[1]) {
      setRange({
        label: moment(range[0]).format('DD/MM/YYYY') + ' - ' + moment(range[1]).format('DD/MM/YYYY'),
        slug: 'custom'
      });
      setIsComponentVisible(false);
      onSelectDate({
        label: 'Tùy chỉnh',
        slug: 'custom',
        range: {
          startDate: moment(range[0]).unix(),
          endDate: moment(range[1]).endOf('day').unix()
        }
      });
    }
  };

  return (
    <>
      <div className="dropdown" ref={ref}>
        <button className="dropdown-toggle btn-filter" type="button" onClick={() => setIsComponentVisible(prev => !prev)}>
          <img className="filter-icon" src={IconFilter} alt="" width={24} /> {range.label}
        </button>
        {range.slug !== 'all' && <span className="btn-remove-filter" onClick={() => filterHandler('all')}>&times;</span>}
        <div className="dropdown-menu" style={{ display: isComponentVisible ? 'block' : 'none' }}>
          <div className="specific-date">
            {rangeDate.map((item, index) => (
              <button
                key={index}
                disabled={onSelect}
                className="btn"
                type="button"
                onClick={() => filterHandler(item.slug)}
              >{item.label}</button>
            ))}
          </div>
          <CustomInputDate
            onDateChange={handleDateChange}
            disabled={onSelect}
          />
        </div>
      </div>
    </>
  )
}

export default FilterDate;
